import Services from './services'

export default function FloatPanel() {
  const { openPrepayBooking } = useCtx('userId')
  const t = useI18n()

  return (
    <div className='w-full fixed bottom-0 py-5 md:py-4 md:top-[4rem] md:sticky  md:shadow-none'
      style={ { zIndex: 1 } }
    >
      <div className='container md:space-y-3 '>
        <Services className='hidden md:block'/>
        <C.Blur><div className='py-8'/></C.Blur>
        <C.Button className='h-[2.8rem] md:h-[2.4rem]' fullWidth onClick={ openPrepayBooking }>{ t('page:userId.book') }</C.Button>
      </div>
    </div>
  )
}
